import React from "react";
import styled from "styled-components";

interface ContentWrapperProps {
  className?: string;
}

const StyledContainer = styled("div")`
  font-size: 13px;
  font-family: ${({ theme }) => theme.regularTextTypeface};
  color: ${({ theme }) => theme.regularTextColor};
  background-color: ${({ theme }) => theme.greyBackground};
  .form-control {
    font-size: 13px;
  }
  min-height: 100%;
`;

export default function ContentWrapper(props: React.PropsWithChildren<ContentWrapperProps>) {
  return <StyledContainer className={props.className}>{props.children}</StyledContainer>;
}
